import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { AppProviders } from "@/app/providers";
import { createQueryClient } from "@/shared/api/query-client";
import { router } from "@/app/router";
import { initI18n } from "@/shared/i18n";
import { startThemeSync } from "@/shared/theme/theme";

import "@/index.css";

const container = document.getElementById("root");
if (container === null) {
  throw new Error("Élément #root introuvable dans index.html");
}

// i18n est initialisé AVANT le premier rendu : sinon le premier affichage montre
// les clés brutes puis clignote vers les traductions.
await initI18n();

// Même raison pour le thème, depuis `localStorage` : attendre la réponse de
// `/users/me/settings` afficherait une page claire avant de basculer en sombre.
startThemeSync();

createRoot(container).render(
  <StrictMode>
    <AppProviders client={createQueryClient()}>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
);
